export const PERMS = {
    READ: 'carrier_contacts.read',
    UPDATE: 'carrier_contacts.update',
    DELETE: 'carrier_contacts.delete',
    CREATE: 'carrier_contacts.create',
}
